// ErrorContext.js
import React, { createContext, useState, useContext } from 'react';
const ErrorContext = createContext();

export const useErrorContext = () => useContext(ErrorContext);

export const ErrorProvider = ({ children }) => {
    
    const [error, setError] = useState({});

    // Function to set error
    const setValidationError = (field, message) => {
        setError((prevState) => ({
            ...prevState,
            [field]: message,
        }));
    };

    // Function to clear a specific error
    const clearError = (field) => {
        setError((prevState) => {
            const newState = { ...prevState };
            delete newState[field];
            return newState;
        });
    };

    // Function to clear all errors
    const clearAllErrors = () => {
        setError({});
    };

    return (
        <ErrorContext.Provider value={{ error, setValidationError, clearError, clearAllErrors }}>
            {children}
        </ErrorContext.Provider>
    );
};
